import React from 'react';
import {Show, DateField, ReferenceField, SimpleShowLayout, TextField} from 'react-admin';

const DonationShow = (props) => (
    <Show{...props}>
        <SimpleShowLayout>
            {/*<TextInput source="id"/>*/}
            <TextField source="amount" label="Montant"/>
            <TextField source="firstname" label="Prénom"/>
            <TextField source="lastname" label="Nom"/>
            <DateField source="donation_date" label="Date du don" defaultValue={Date.now()}/>
            <ReferenceField
                label="Campagne"
                source="campaign_id"
                reference="campaign"
            >
                <TextField source="abstract_title"/>
            </ReferenceField>
            <TextField source="affectation_code" label="Code affectation"/>
            <TextField source="origin_code" label="Code origine"/>
        </SimpleShowLayout>
    </Show>
)

export default DonationShow;
